module.exports = __webpack_public_path__ + "img/logo.f86bece3.svg";